import web from "@/core/middlewares/web";
import prefix from "@/core/utils/prefix-routes";

let menuIndex = () =>
  import(/* webpackChunkName: "menu" */ "@/views/sections/menu/Index.vue");
let menuShow = () =>
  import(/* webpackChunkName: "menu" */ "@/views/sections/menu/Show.vue");
let subMenuShow = () =>
  import(/* webpackChunkName: "menu" */ "@/views/sections/menu/Submenu.vue");
let certificate = () =>
  import(/* webpackChunkName: "settings" */ "@/views/sections/Certificate.vue");
let sliderIndex = () =>
  import(/* webpackChunkName: "slider" */ "@/views/sections/slider/Index.vue");
let sliderEdit = () =>
  import(/* webpackChunkName: "slider" */ "@/views/sections/slider/Edit.vue");
let slideCreate = () =>
  import(
    /* webpackChunkName: "slide" */ "@/views/sections/slider/slide/Create.vue"
  );
let slideEdit = () =>
  import(
    /* webpackChunkName: "slide" */ "@/views/sections/slider/slide/Edit.vue"
  );
let socialsIndex = () =>
  import(
    /* webpackChunkName: "social-networks" */ "@/views/sections/social-networks/Index"
  );
let socialsCreate = () =>
  import(
    /* webpackChunkName: "social-networks" */ "@/views/sections/social-networks/Create"
  );
let header = () =>
  import(/* webpackChunkName: "sections" */ "@/views/sections/Header");
let footer = () =>
  import(/* webpackChunkName: "sections" */ "@/views/sections/Footer.vue");
let statistics = () =>
  import(
    /* webpackChunkName: "sections" */ "@/views/sections/StatisticsHome.vue"
  );
let homeCover = () =>
  import(/* webpackChunkName: "sections" */ "@/views/sections/HomeCover.vue");
let quickAccess = () =>
  import(/* webpackChunkName: "sections" */ "@/views/sections/QuickAccess.vue");
let formsIndex = () =>
  import(
    /* webpackChunkName: "paper-forms" */ "@/views/sections/paper-forms/Index"
  );
let companyPanel = () =>
  import(/* webpackChunkName: "paper-forms" */ "@/views/sections/Companies");
let textSliderIndex = () =>
  import(
    /* webpackChunkName: "text-slider" */ "@/views/sections/text-slider/Index.vue"
  );
let textSliderEdit = () =>
  import(
    /* webpackChunkName: "text-slider" */ "@/views/sections/text-slider/Edit.vue"
  );
let textSlideCreate = () =>
  import(
    /* webpackChunkName: "text-slider-items" */ "@/views/sections/text-slider/slide/Create.vue"
  );
let textSlideEdit = () =>
  import(
    /* webpackChunkName: "text-slider-items" */ "@/views/sections/text-slider/slide/Edit.vue"
  );

export default [
  ...prefix("/sections", [
    {
      path: "header",
      name: "sections.header",
      component: header,
      meta: {
        middleware: web,
        permissions: ["settings:header"],
        title: "تنظیمات هدر",
      },
    },
    {
      path: "statistics",
      name: "sections.statistics",
      component: statistics,
      meta: {
        middleware: web,
        permissions: ["settings:mainPageCounters"],
        title: "آمار صفحه اصلی",
      },
    },
    {
      path: "home-cover",
      name: "sections.home-cover",
      component: homeCover,
      meta: {
        middleware: web,
        permissions: ["settings:mainPageCover"],
        title: "کاور صفحه اصلی",
      },
    },
    {
      path: "footer",
      name: "sections.footer",
      component: footer,
      meta: {
        middleware: web,
        permissions: ["settings:footer"],
        title: "تنظیمات فوتر",
      },
    },
    {
      path: "menu",
      name: "sections.menu.index",
      component: menuIndex,
      meta: {
        middleware: web,
        permissions: ["menus:viewAny"],
        title: "منو ها",
      },
    },
    {
      path: "menu/:id",
      name: "sections.menu.show",
      component: menuShow,
      meta: {
        middleware: web,
        permissions: ["menus:viewAny"],
        title: "مشاهده زیرمنو",
      },
    },
    {
      path: "menu/:id/:submenu",
      name: "sections.submenu.show",
      component: subMenuShow,
      meta: {
        middleware: web,
        permissions: ["menus:viewAny"],
        title: "مشاهده زیرمنو سطح سوم",
      },
    },
    {
      path: "certificate",
      name: "sections.certificate",
      component: certificate,
      meta: {
        middleware: web,
        permissions: ["certificates:viewAny"],
        title: "نمادها",
      },
    },
    {
      path: "slider",
      name: "sections.slider",
      component: sliderIndex,
      meta: {
        middleware: web,
        permissions: ["sliders:viewAny", "sliders:view"],
        title: "اسلایدر",
      },
    },
    {
      path: "slider/:id",
      name: "sections.slider.slide",
      component: sliderEdit,
      meta: {
        middleware: web,
        permissions: ["sliders:update", "sliders:view"],
        title: "  اسلایدر",
      },
    },
    {
      path: "slider/:id/create",
      name: "sections.slider.slide.create",
      component: slideCreate,
      meta: {
        middleware: web,
        permissions: ["sliders:create"],
        title: "ایجاد اسلاید ",
      },
    },
    {
      path: "slider/:slider/slide/:id",
      name: "sections.slider.slide.show",
      component: slideEdit,
      meta: {
        middleware: web,
        permissions: ["sliders:update", "sliders:view"],
        title: "  اسلاید ",
      },
    },
    {
      path: "quick-access",
      name: "sections.quick-access",
      component: quickAccess,
      meta: {
        middleware: web,
        permissions: ["quick-access-links:viewAny"],
        title: "  دسترسی سریع ",
      },
    },
    {
      path: "social-networks",
      name: "sections.social-networks.index",
      component: socialsIndex,
      meta: {
        middleware: web,
        permissions: ["social-networks:viewAny"],
        title: "شبکه های اجتماعی",
      },
    },
    {
      path: "social-networks/create",
      name: "sections.social-networks.create",
      component: socialsCreate,
      meta: {
        middleware: web,
        permissions: ["social-networks:create"],
        title: "افزودن شبکه اجتماعی",
      },
    },
    {
      path: "paper-forms",
      name: "sections.paper-forms",
      component: formsIndex,
      meta: {
        middleware: web,
        permissions: ["paper-forms:viewAny"],
        title: "فرم ها",
      },
    },
    {
      path: "company-panel",
      name: "sections.company-panel",
      component: companyPanel,
      meta: {
        middleware: web,
        permissions: ["settings:companyPanel"],
        title: "تنظیمات پنل شرکت‌ها",
      },
    },
    {
      path: "text-slider",
      name: "sections.text-slider.index",
      component: textSliderIndex,
      meta: {
        middleware: web,
        permissions: ["text-sliders:viewAny", "text-sliders:view"],
        title: "مدیریت اسلایدرهای متنی",
      },
    },
    {
      path: "text-slider/:id",
      name: "sections.text-slider.edit",
      component: textSliderEdit,
      meta: {
        middleware: web,
        permissions: ["text-sliders:viewAny", "text-sliders:view"],
        title: "مدیریت عبارات اسلایدر متنی",
      },
    },
    {
      path: "text-slider/:id/slide/create",
      name: "sections.text-slider.slide.create",
      component: textSlideCreate,
      meta: {
        middleware: web,
        permissions: ["text-sliders:create"],
        title: "ایجاد عبارت جدید اسلایدر",
      },
    },
    {
      path: "text-slider/slide/:id/edit",
      name: "sections.text-slider.slide.edit",
      component: textSlideEdit,
      meta: {
        middleware: web,
        permissions: ["text-sliders:update", "text-sliders:view"],
        title: "ویرایش عبارت اسلایدر متنی",
      },
    },
  ]),
];
